import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import formControlWrapStyle from './FormControlWrap.module.scss.js';

const { componentTestLabel } = getTestLabels('FormControlWrap');
const FormControlWrap = forwardRef((props, ref) => {
    const { className, ...otherProps } = props;
    return (jsx("div", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(formControlWrapStyle['z-form-control-wrap'], className) }));
});
FormControlWrap.displayName = 'FormControlWrap';

export { FormControlWrap };
//# sourceMappingURL=FormControlWrap.js.map
